
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import "@/store/modules/application";
const applicationState = namespace("Application");

import StepBase from "../StepBase.vue";

import GuardianshipAffidavit from "./GuardianshipAffidavit.vue";
import AboutAffiantGa from "./AboutAffiantGA.vue";


import ChildrenDetailsGa from "./childrenDetailsGa/ChildrenDetailsGa.vue";
import CaringForChildGa from "./caringForChildGa/CaringForChildGa.vue";
import BackgroundFamilyViolence from "./BackgroundFamilyViolence.vue";
import BackgroundCivilCourtProceedings  from "./backgroundCivilProceedingsGa/BackgroundCivilCourtProceedings.vue";
import BackgroundCriminalHistory from "./BackgroundCriminalHistory.vue";

import Exhibits from "./Exhibits.vue";

import FilingGa from "./FilingGA.vue";
import ElectronicFilingStatementGa from "./ElectronicFilingStatementGA.vue";
import ReviewYourAnswersGa from "./reviewGA/ReviewYourAnswersGA.vue";
import PreviewFormsGa from "./reviewGA/PreviewFormsGA.vue";
import PreviewFormsGaEfsp from "./reviewGA/PreviewFormsGaEFSP.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        StepBase,        
        GuardianshipAffidavit,        
        AboutAffiantGa,
        ChildrenDetailsGa,
        CaringForChildGa,
        BackgroundFamilyViolence,
        BackgroundCivilCourtProceedings,
        BackgroundCriminalHistory,
        Exhibits,
        FilingGa,
        ElectronicFilingStatementGa,
        ReviewYourAnswersGa,
        PreviewFormsGa,
        PreviewFormsGaEfsp
    }
})
export default class GuardianshipAffidavitStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
